import { ApplicationRef } from '@angular/core';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { AttributionRelativeModule } from 'SecuritiesApp/ts/features/attribution-relative/attribution-relative.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { AttributionRelativeComponent } from 'SecuritiesApp/ts/features/attribution-relative/components/attribution-relative.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import * as i0 from "@angular/core";
export class MutualFundsAttributionRelativeAppModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(AttributionRelativeComponent);
        appRef.bootstrap(SecurityHeaderControlComponent);
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(SideMenuComponent);
    }
}
MutualFundsAttributionRelativeAppModule.ɵfac = function MutualFundsAttributionRelativeAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsAttributionRelativeAppModule)(); };
MutualFundsAttributionRelativeAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsAttributionRelativeAppModule });
MutualFundsAttributionRelativeAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BaseSecurityPageModule, AttributionRelativeModule] });
